import Popover from 'bootstrap/js/dist/popover.js';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
		el._popover?.dispose?.();
		el._popover = new Popover(el, { trigger: 'focus' });
	});

	[...document.querySelectorAll('.search-form')].forEach((el) => {
		el.addEventListener('submit', (e) => {
			const search = el.querySelector('input');
			if (!search || search.value.length < 1) {
				e.preventDefault();
				search?.focus();
			}
		});
	});
});